// extracted by mini-css-extract-plugin
module.exports = {"container":"UserInfo_container__JjvpT","userLetter":"UserInfo_userLetter__16Wec","userName":"UserInfo_userName__1o1u7"};